import * as React from 'react';
import {
    ContextActionType,
    ModalContext,
    ModalFormTitle,
    useDumbActionsContext,
} from '@europrocurement/flexy-components';
import { ColumnDatatable } from '@europrocurement/flexy-datatable';

import { useDispatch } from 'react-redux';
import { FaOptionIcon, addItem } from '@europrocurement/l2d-icons';
import { GroupementGroupementRead } from '@europrocurement/l2d-domain/openApi/ApiOffre';
import { IconName } from '@fortawesome/pro-duotone-svg-icons';
import { AnyAction } from '@reduxjs/toolkit';
import { useOffreService } from '@europrocurement/l2d-domain';
import { useDefaultContextActions } from '@europrocurement/l2d-modules/hooks';
import { Typography } from '@mui/material';
import Form from './Form';
import { displayCustomValue, getStringColumn } from '../listings';
import ListingWithSearchAndPreview from '../components/ListingWithSearchAndPreview';
import { PossibleTypes } from '../../Societes';

const Panel: React.FunctionComponent = function () {
    const { modalActions } = React.useContext(ModalContext);

    const { offerGroupModel: model } = useOffreService();
    const { backContextActions } = useDefaultContextActions();

    const dispatch = useDispatch();

    const reloadList = () =>
        dispatch(model.datasourcesThunks.main.getData({}) as unknown as AnyAction);

    const listingButton = {
        label: 'Créer un groupement',
        icon: addItem,
        action: () =>
            modalActions.call(
                <>
                    <ModalFormTitle
                        icon={model.icon}
                        title="Création d'un groupement"
                    />
                    <Form
                        isCreate
                        afterSubmit={reloadList}
                    />
                </>,
            ),
    };

    const contextActions: ContextActionType[] = React.useMemo(
        () => [
            {
                name: 'Créer un groupement',
                icon: <FaOptionIcon icon={['fas', 'plus-circle']} />,
                action: listingButton.action,
            },
            ...backContextActions,
        ],
        [backContextActions, listingButton.action],
    );

    useDumbActionsContext(contextActions);

    const columns: ColumnDatatable<GroupementGroupementRead>[] = [
        getStringColumn('libelle'),
        {
            label: 'Domaine',
            displayLabel: true,
            render: ({ domaine: domain }) => (
                <Typography
                    variant="l2dtableCell"
                    color="text.gris70"
                >
                    {domain?.libelle}
                </Typography>
            ),
            isDisplayed: true,
            sortable: false,
            field: 'domaine',
        },
        {
            label: 'Icône',
            displayLabel: true,
            render: ({ iconeName: iconName }) => {
                if (iconName) {
                    return (
                        <Typography
                            variant="l2dtableCell"
                            color="text.gris70"
                        >
                            <FaOptionIcon icon={['fad', iconName as IconName]} />
                        </Typography>
                    );
                }
                return null;
            },
            isDisplayed: true,
        },
        displayCustomValue(
            'dependencies',
            (catalogs) => (catalogs.length > 0 ? catalogs.length.toString() : '(vide)'),
            'Nombre de catalogue(s)',
        ),
    ];

    return (
        <ListingWithSearchAndPreview
            listingTitle="Liste des groupements"
            listingButton={listingButton}
            listingColumns={columns}
            form={Form}
            model={model}
            filtersControl={false}
            searchBarType={PossibleTypes.Group}
        />
    );
};

export default Panel;
